__turbopack_context__.v({
  "appStoreBadge": "appDownloadButtons-module-scss-module__EJPDJG__appStoreBadge",
  "badgesWrapper": "appDownloadButtons-module-scss-module__EJPDJG__badgesWrapper",
  "mainWrapper": "appDownloadButtons-module-scss-module__EJPDJG__mainWrapper",
});
